import Info from './ProfileComponents/InfoProfile/Info'
import UserHome from '../UserHome/UserHome'

import Profile from "../../assets/profile.jpg"
import img1 from "../../assets/User-post/img1.jpg"
import img2 from "../../assets/User-post/img2.jpg"
import img3 from "../../assets/User-post/img3.jpg"
import { useEffect, useState } from 'react'
import "../Profile/ProfileMiddle.css"
import { API_BASE_URL, API_KEY } from '../../constants';
import axios from 'axios';

import { get } from '../../service/apiService';

import moment from 'moment'
import ProfileInputPost from './ProfileComponents/ProfileInputPost'
import axiosInstance from '../../axios'
const ProfileMiddle = ({following,
                        search,
                        images,
                        setImages,
                        profileImg,
                        coverImg,
                        setProfileImg,
                        setCoverImg,
                        name,
                        setName,
                        userName,
                        setUserName,
                        modelDetails,
                        setModelDetails}) => {

  const [userPostData ,setUserPostData] =useState([])
  const [body,setBody] =useState("")
  const [importFile,setImportFile] =useState("")
  const [EditMemberButtonVisibility,setEditMemberButtonVisibility]=useState(false)
  const [postInputBoxVisibility,setPostInputBoxVisibility]=useState(false)
  const [privacyStatus,setPrivacyStatus]=useState("private")

  const loggedInUserObj=JSON.parse(localStorage.getItem('userData'))
  const loggedInUserId=loggedInUserObj.user_profile.member_id
  const isSuperUser=loggedInUserObj.user_profile.is_superuser
  const getMemberOwnerUrl='member-owners/?search='

useEffect(() => {
  const fetch_post_details=async () =>{
  try {

      const response = await axiosInstance.get(
        `${API_BASE_URL}member-stories/`+modelDetails.ModelId,
        {
          headers: {
            'X-Api-Key': API_KEY,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if(response && response.data){
         
          response.data.data.results.forEach(post => {
            const isLiked = post.likes.find(each_like => each_like.liker === loggedInUserId);
            if(isLiked){
              post.is_liked_by_me = true;
              post.my_liked_id=isLiked.id;
            }
          });
          setUserPostData(response.data.data.results)

        }

    } catch (error) {
      console.error('Uploading profile pic:', error);
    }
  }
  const fetchOwnerDetails = async () => {
  
    try {
          if(isSuperUser){
            setEditMemberButtonVisibility(false)
            setPostInputBoxVisibility(false)
          }
          else{
                  const responseData = await axiosInstance.get(API_BASE_URL+getMemberOwnerUrl+modelDetails.ModelId);
                  if(responseData && responseData.data && responseData.data[0]){
                      const owner_id=responseData.data[0].rel_member.member_id
                      if(loggedInUserId==owner_id)
                      {
                        setEditMemberButtonVisibility(false)
                        setPostInputBoxVisibility(false)
                      }
                      else{
                        setEditMemberButtonVisibility(true)
                        setPostInputBoxVisibility(true)
                      }
                    }
                  else{
                    setEditMemberButtonVisibility(true)
                    setPostInputBoxVisibility(true)
                  }
                }
    }
   catch (error) {
      console.error("An error occurred while fetching data:", error);
    }};
  fetch_post_details();
  fetchOwnerDetails();

}, []);




  const handleSubmit =async(e)=>{
    e.preventDefault()
    const id =userPostData.length ? userPostData[userPostData.length -1].id +1 :1
    const username=modelDetails.ModelName
    const profilepicture=profileImg
    const datetime=moment.utc(new Date(), 'yyyy/MM/dd kk:mm:ss').local().startOf('seconds').fromNow()
    const img= images ? {img:URL.createObjectURL(images)} : null
    let formData = new FormData();
    formData.append("attachments", images);
    formData.append("id", id);
    formData.append("comments", []);
    formData.append("likes", []);
    formData.append("views", []);
    formData.append("status", 1);
    formData.append("publish_as", privacyStatus);
    formData.append("title", "story");
    formData.append("slug", "story");
    formData.append("content", body);
    formData.append("create_at", '');
    formData.append("updated_at",'');
    formData.append("author", loggedInUserId);
    formData.append("profile", modelDetails.ModelId);
    const post_details=async() =>{
      try {
          const response = await axiosInstance.post(
            `${API_BASE_URL}story-with-attachments`,formData,
            {
              headers: {
                'X-Api-Key': API_KEY,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if(response && response.data && response.data.data){
            
            const obj ={id:response.data.data.id,
                      comments: [],
                      likes: [],
                      views: [],
                      attachments: img?[{attachment:img.img}]:[],
                      status: 1,
                      publish_as: privacyStatus,
                      title: "",
                      slug: "",
                      content: body,
                      create_at: response.data.data.create_at,
                      updated_at: null,
                      author: loggedInUserId,
                      profile: modelDetails.ModelId,
                      profilepicture:profilepicture,
                      username:username,
                      datetime:datetime,
                      }
                      const insert =[...userPostData,obj]
                      setUserPostData(insert)
                      setBody("")
                      setImages(null)
            }
    
        } catch (error) {
          console.error('Uploading post data:', error);
        }
      }
    post_details();
    
  }


  

  // const [searchResults,setSearchResults] =useState("")
    
  //   useEffect(()=>{
  //     const searchData = userPostData.filter((val)=>(
  //       (val.body.toLowerCase().includes(search.toLowerCase()))
  //      ||
  //      (val.username.toLowerCase().includes(search.toLowerCase()))
  //      ))
  //      setSearchResults(searchData)
       
  //   },[userPostData,search])

   

    

  return (
    <div className='profileMiddle'>
        <Info 
        modelDetails ={modelDetails}
        setModelDetails={setModelDetails}
        profileImg={profileImg}
        coverImg={coverImg}
        setProfileImg={setProfileImg}
        setCoverImg={setCoverImg}
        userPostData={userPostData}
        following={following}
        name={name}
        setName={setName}
        userName={userName}
        setUserName={setUserName}
        EditMemberButtonVisibility={EditMemberButtonVisibility}
        loggedInUserId={loggedInUserId}
        isSuperUser={isSuperUser}
        />
        
        <ProfileInputPost
        modelDetails={modelDetails}
        profileImg={profileImg}
        handleSubmit={handleSubmit}
        body ={body}
        setBody ={setBody}
        importFile ={importFile}
        setImportFile ={setImportFile}
        images={images}
        setImages={setImages}
        postInputBoxVisibility={postInputBoxVisibility}
        setPrivacyStatus={setPrivacyStatus}
        />
        
        <UserHome 
        modelDetails={modelDetails}
        profileImg={profileImg}
        setUserPostData={setUserPostData}
        userPostData={userPostData}
        images={images}
        />
    </div>
  )
}

export default ProfileMiddle